module.exports = __webpack_public_path__ + "img/navegacao-primeiro.9456e145.svg";